import script from "./HistorialEnvios.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialEnvios.vue?vue&type=script&setup=true&lang=js"

import "./HistorialEnvios.vue?vue&type=style&index=0&id=efbb0ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbb0ce0"]])

export default __exports__